import { ReactNode, useState } from 'react'

import { ConfirmModal } from '@/shared/ui'
import { Toast } from '@/shared/ui/Toast'

export interface ConfirmPopupProps {
	children: ReactNode
	title: string
	description?: string
	okText?: string
	cancelText?: string
	onConfirm?: () => void
	onCancel?: () => void
}

export const ConfirmPopup = (props: ConfirmPopupProps): JSX.Element => {
	const { children, title, description, okText = 'Удалить', cancelText = 'Отмена', onConfirm, onCancel } = props
	const [isToastOpen, setIsToastOpen] = useState(false)

	const handleConfirm = () => {
		setIsToastOpen(true)
		onConfirm?.()
	}

	return (
		<>
			<ConfirmModal
				title={title}
				description={description}
				okText={okText}
				cancelText={cancelText}
				onConfirm={handleConfirm}
				onCancel={onCancel}>
				{children}
			</ConfirmModal>

			<Toast isOpen={isToastOpen} onClose={() => setIsToastOpen(false)} position="bottom-center" duration={3000}>
				Товар удалён
			</Toast>
		</>
	)
}
